<template>
  <b-card v-if="announcements.length > 0" no-body class="border-0 border-bottom-only">
    <template #header>
      <div class="d-flex">
        <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="1.2" shift-v="-3"></b-icon>
        <strong class="flex-grow-1" style="color: red; padding-left: 10px;">Announcements ({{ announcements.length }})</strong>
        <b-button variant="link" @click="showAnnouncements = !showAnnouncements">
          <b-icon :icon="'chevron-double-' + (showAnnouncements ? 'up' : 'down')" />
        </b-button>
      </div>
    </template>
    <b-collapse v-model="showAnnouncements" style="max-height: 300px; overflow-y: auto;">
      <b-card no-body class="mb-1" v-for="item in announcements" :key="item.announcement_key">
        <b-card-header
          v-b-toggle="'collapse-' + item.announcement_key"
          class="d-flex align-items-center clickable-title"
          style="color: red;"
        >
          <b-icon
            :icon="announcementCollapseIds[item.announcement_key] ? 'chevron-down' : 'chevron-right'"
            class="mr-2"
          />
          <strong>{{ item.title }}
            <b-icon
              v-if="item.announcement_document_key !== null"
              icon="file-earmark-text"
              style="color: blue"
              v-b-tooltip.hover title="Announcement contains document">
            </b-icon>
          </strong>
        </b-card-header>
        <b-collapse
          :id="'collapse-' + item.announcement_key"
          class="p-3"
          @show="$set(announcementCollapseIds, item.announcement_key, true)"
          @hide="$set(announcementCollapseIds, item.announcement_key, false)"
        >
          <div v-html="item.announcement"></div>
          <hr />
          <small class="text-muted d-block">
            Display Start Date: {{ formatDate(item.start_date) }}
          </small>
          <small class="text-muted d-block">
            Created by {{ item.created_username }} on {{ formatDate(item.created) }}
          </small>
          <small
            v-if="item.updated && item.updated_username"
            class="text-muted d-block"
          >
            Modified by {{ item.updated_username }} on {{ formatDate(item.updated) }}
          </small>
          <b-button
            v-if="item.announcement_document_key !== null"
            variant="info"
            size="sm"
            class="mt-2"
            @click="viewDocument(item)"
          >
            <b-icon icon="file-earmark-text"></b-icon>
            View Attached Document
          </b-button>
        </b-collapse>
      </b-card>
    </b-collapse>
  </b-card>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import _ from 'underscore';
import { format, parseISO } from 'date-fns';

@Component
export default class AnnouncementList extends Vue {
  data() {
    return {
      showAnnouncements: true,
      announcementCollapseIds: {},
      announcements: []
    }
  }

  get user() {
    return this.$store.getters['session/currentUser'] || {};
  }

  formatDate(dateStr) {
    const date = parseISO(dateStr);
    return format(date, "MM/dd/yyyy 'at' hh:mm a");
  }

  async viewDocument(announcement) {
    if (announcement && announcement.announcement_document_key) {
      const url = `/api/member/announcements/${announcement.announcement_document_key}/document`;
      window.open(url, '_blank');
    }
  }

  async mounted() {
    this.announcements = await this.$store.dispatch('getAnnouncements', { ubcId: this.user.ubcId });
    this.announcements.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
  }
}
</script>

<style scoped>
.border-bottom-only {
  border-bottom: 1px solid #dee2e6 !important;
}

.clickable-title {
  cursor: pointer;
  background-color: #f7f7f7;
}

.clickable-title:hover {
  background-color: #e9ecef;
}
</style>
